export enum Step {
  SpeedTest,
  BitrateTest,
}

export enum Stage {
  Welcome = 0,
  ChooseConfiguration = 1,
  ChooseWebcam = 2,
  RunTest = 3,
}
